module.exports = __webpack_public_path__ + "img/couponget@2x.0e82577a.png";